import {
    CodeIcon,
    TemplateIcon,
    ChevronDownIcon 
  } from '@heroicons/react/solid';

import React, { useState, useEffect, BubbleMenu } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Document from '@tiptap/extension-document';
import Text from '@tiptap/extension-text';
import Paragraph from '@tiptap/extension-paragraph';
import Heading from '@tiptap/extension-heading';
import Bold from '@tiptap/extension-bold';
import Italic from '@tiptap/extension-italic';
import Underline from '@tiptap/extension-underline';
import Strike from '@tiptap/extension-strike';
import BulletList from '@tiptap/extension-bullet-list';
import OrderedList from '@tiptap/extension-ordered-list';
import ListItem from '@tiptap/extension-list-item';
import Blockquote from '@tiptap/extension-blockquote';
import Code from '@tiptap/extension-code';
import CodeBlock from '@tiptap/extension-code-block';
import Link from '@tiptap/extension-link';
import TextAlign from '@tiptap/extension-text-align';
import Placeholder from '@tiptap/extension-placeholder'

const TextEditor = ({ onChange, initialValue }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [currentAlignment, setCurrentAlignment] = useState('left');

    const editor = useEditor({
        extensions: [
        Document,
        Placeholder.configure({
          // Use a placeholder:
          placeholder: 'Motivation: my ex-girlfriend dumped me :(',
        }),
        Paragraph,
        Text,
        Heading.configure({
            levels: [1, 2, 3, 4, 5, 6],
        }),
        StarterKit.configure({
            bulletList: false,
            orderedList: false,
        }),
        Bold,
        Italic,
        Underline,
        Strike,
        BulletList,
        OrderedList,
        ListItem,
        Blockquote,
        Code,
        CodeBlock,
        Link.configure({
            openOnClick: true,
            linkOnPaste: true,
            autolink: true,
        }),
        TextAlign.configure({
            types: ['heading', 'paragraph', 'listItem'], // Ensure alignment is applied to list items
        }),
        ],
        content: initialValue,
        onUpdate: ({ editor }) => {
        const content = editor.getHTML();
        onChange(content);
        },
    });

    const addLink = () => {
      const url = window.prompt('Enter the URL');
      if (url) {
        editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
      }
    };
  
    const removeLink = () => {
      editor.chain().focus().unsetLink().run();
    };
  
    const editLink = () => {
      const previousUrl = editor.getAttributes('link').href;
      const newUrl = window.prompt('Edit the URL', previousUrl);
      if (newUrl) {
        editor.chain().focus().extendMarkRange('link').setLink({ href: newUrl }).run();
      }
    };

    useEffect(() => {
      if (editor) {
        const updateAlignment = () => {
          if (editor.isActive({ textAlign: 'left' })) {
            setCurrentAlignment('left');
          } else if (editor.isActive({ textAlign: 'center' })) {
            setCurrentAlignment('center');
          } else if (editor.isActive({ textAlign: 'right' })) {
            setCurrentAlignment('right');
          } else if (editor.isActive({ textAlign: 'justify' })) {
            setCurrentAlignment('justify');
          } else {
            setCurrentAlignment('left');
          }
        };
  
        editor.on('transaction', updateAlignment);
        return () => editor.off('transaction', updateAlignment);
      }
    }, [editor]);

    if (!editor) {
        return null;
    }

    const handleSetHeading = (level) => {
      if (level === 0) {
      editor.chain().focus().setParagraph().run();
      } else {
      editor.chain().focus().setHeading({ level }).run();
      }
    };

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const handleTextAlign = (align) => {
      editor.chain().focus().setTextAlign(align).run();
      setDropdownOpen(false); // Close dropdown after selection
    };

    const alignmentIcon = {
      left: 'fas fa-align-left',
      center: 'fas fa-align-center',
      right: 'fas fa-align-right',
      justify: 'fas fa-align-justify',
    };

    

    return (
    <div>
      <div className="flex border border-2 border-b-0 border-black py-1 rounded-t justify-between">
        <button
          type="button"
          onClick={() => editor.chain().focus().undo().run()}
          className="px-2 border-none rounded bg-transparent"
        >
          <i class="fa-solid fa-rotate-left" style={{ color: "#000000" }}></i>
        </button>

        {/* Redo Button */}
        <button
          type="button"
          onClick={() => editor.chain().focus().redo().run()}
          className="px-2 border-none rounded bg-transparent"
        >
          <i class="fa-solid fa-rotate-right" style={{ color: "#000000" }}></i>
        </button>
        <select
          onChange={(e) => handleSetHeading(Number(e.target.value))}
          className=" border-none"
          style={{ WebkitAppearance: 'none', MozAppearance: 'none', paddingLeft:10,  paddingRight:30, marginRight:0 }}
        >
          <option value="0">Normal Text</option>
          <option value="1">Heading 1</option>
          <option value="2">Heading 2</option>
          <option value="3">Heading 3</option>
          <option value="4">Heading 4</option>
          <option value="5">Heading 5</option>
          <option value="6">Heading 6</option>
        </select>
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleBold().run()}
          className={`px-[7px] pt-[0.5px] mx-1 border-none rounded ${editor.isActive('bold') ? 'bg-black text-white' : 'bg-transparent'}`}
        >
            <i class="fa-solid fa-bold"></i>
          
        </button>
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleItalic().run()}
          className={`px-[7px] pt-[0.5px] mx-1 border-none rounded  ${editor.isActive('italic') ? 'bg-black text-white' : 'bg-transparent'}`}
        >
            <i class="fa-solid fa-italic"></i>
        </button>
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleUnderline().run()}
          className={`px-[7px] pt-[0.5px] mx-1 border-none rounded ${editor.isActive('underline') ? 'bg-black text-white' : 'bg-transparent'}`}
        >
          <i class="fa-solid fa-underline"></i>
        </button>
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleStrike().run()}
          className={`px-[5px] pt-[0.5px] mx-1 border-none rounded ${editor.isActive('strike') ? 'bg-black text-white' : 'bg-transparent'}`}
        >
          <i class="fa-solid fa-strikethrough"></i>
        </button>
        <button
          type="button"
          onClick={addLink}
          className={`px-[7px] mx-1 border-none rounded  ${editor.isActive('link') ? 'bg-black text-white' : 'bg-transparent'}`}
        >
          <i class="fa-solid fa-link"></i>
        </button>
        <div className="relative">
          <button
            type="button"
            onClick={toggleDropdown}
            className="pl-1 mx-1 border-none rounded flex items-center"
          >
            <i className={alignmentIcon[currentAlignment]}></i>
            <ChevronDownIcon className='w-5 h-5 pl-1' />
          </button>

          {dropdownOpen && (
            <div className="absolute left-0 mt-2 w-fit bg-white border border-black rounded shadow-solid z-10">
              <button
                type="button"
                onClick={() => handleTextAlign('left')}
                className={`w-full px-4 py-2 text-left  rounded ${
                  currentAlignment === 'left' ? 'bg-black text-white' : ''
                }`}
              >
                <i className="fas fa-align-left"></i>
              </button>
              <button
                type="button"
                onClick={() => handleTextAlign('center')}
                className={`w-full px-4 py-2 text-left  rounded ${
                  currentAlignment === 'center' ? 'bg-black rounded text-white' : ''
                }`}
              >
                <i className="fas fa-align-center"></i>
              </button>
              <button
                type="button"
                onClick={() => handleTextAlign('right')}
                className={`w-full px-4 py-2 text-left rounded ${
                  currentAlignment === 'right' ? 'bg-black rounded text-white' : ''
                }`}
              >
                <i className="fas fa-align-right"></i>
              </button>
              <button
                type="button"
                onClick={() => handleTextAlign('justify')}
                className={`w-full px-4 py-2 text-left rounded ${
                  currentAlignment === 'justify' ? 'bg-black rounded text-white' : ''
                }`}
              >
                <i className="fas fa-align-justify"></i>
              </button>
            </div>
          )}
        </div>

        <button
          type="button"
          onClick={() => editor.chain().focus().toggleBulletList().run()}
          className={`px-[7px] mx-1 border-none rounded ${editor.isActive('bulletList') ? 'bg-black text-white' : 'bg-transparent'}`}
        >
            
            {editor.isActive('bulletList') ? <i class="fa-solid fa-list" style={{color: "#ffffff"}}></i> : <i class="fa-solid fa-list" ></i>}
          {/* Bullet List */}
        </button>
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
          className={`px-[5px] mx-1 border-none rounded ${editor.isActive('orderedList') ? 'bg-black text-white' : 'bg-transparent'}`}
        >
          {editor.isActive('orderedList') ? <i class="fa-solid fa-list-ol" style={{color: "#ffffff"}}></i> : <i class="fa-solid fa-list-ol"></i>}
        </button>
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleBlockquote().run()}
          className={`px-[5px] mx-1 border-none rounded ${editor.isActive('blockquote') ? 'bg-black text-white' : 'bg-transparent'}`}
        >
            {editor.isActive('blockquote') ? <i class="fa-solid fa-quote-right" style={{color: "#ffffff"}}></i> : <i class="fa-solid fa-quote-right"></i>}
            
        </button>
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleCode().run()}
          className={`px-[3px] mx-1 border-none text-sm rounded ${editor.isActive('code') ? 'bg-black text-white' : 'bg-transparent'}`}
        >
            {/* {editor.isActive('code') ? <CodeIcon className="h-5 w-5" color="#FFFFFF" /> : <CodeIcon className="h-5 w-5" />} */}
            <i class="fa-solid fa-code"></i>
        </button>
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleCodeBlock().run()}
          className={`px-1 mx-1 border-none rounded ${editor.isActive('codeBlock') ? 'bg-black text-white' : 'bg-transparent'}`}
        >
            {/* ({editor.isActive('codeBlock') ? }) */}
            {/* {editor.isActive('codeBlock') ? <i class="fa-regular fa-file-code" style={{color: "#ffffff"}}></i> : <i class="fa-solid fa-file-code" style={{color: "#000000"}}></i>} */}
          <i class="fa-solid fa-laptop-code"></i>
        </button>
        
        {/* <button
          onClick={removeLink}
          className="p-2 border bg-red-500 text-white"
        >
          Remove Link
        </button> */}
        
      </div>
      <EditorContent editor={editor} className=" p-2 border-2 border-black bg-white rounded-b focus:outline-none min-h-48" />

    </div>
  );
};

export default TextEditor;

//       {/* Bubble Menu for Links */}
//       {/* {editor && (
//   <BubbleMenu editor={editor} tippyOptions={{ duration: 100 }} shouldShow={({ editor }) => editor.isActive('link')}>
//     <div className="flex items-center space-x-2 p-2 bg-white shadow-lg rounded">
//       <a
//         href={editor.getAttributes('link').href}
//         target="_blank"
//         rel="noopener noreferrer"
//         className="text-blue-500 underline"
//       >
//         {editor.getAttributes('link').href}
//       </a>
//       <button onClick={editLink} className="text-gray-700 hover:text-gray-900">
//         Edit
//       </button>
//       <button onClick={removeLink} className="text-red-500 hover:text-red-700">
//         Remove
//       </button>
//     </div>
//   </BubbleMenu>
// )} */}









